import {
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Autocomplete,
  TextField,
  CircularProgress,
  IconButton,
  Badge,
  Box,
  Tooltip,
  Popover,
  Tab,
  List,
  ListItemText,
  Button,
  Typography,
  Collapse,
  Divider,
  ListItem,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store/appStore";
import React, { useEffect, useMemo, useState } from "react";
import { getTestAnalysis } from "../../../redux/slices/testAttempts";
import { useStyles } from "../../../assets/styles/listTableStyle";
import { useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import { STATUS } from "../../../utils/status";
import debounce from "lodash.debounce";
import { getVendorAction } from "../../../redux/slices/vendor";
import EastIcon from "@mui/icons-material/East";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import CancelIcon from "@mui/icons-material/Cancel";
import BlockIcon from "@mui/icons-material/Block";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import RestoreIcon from "@mui/icons-material/Restore";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const TestAnalysis = () => {
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);
  const [openAutoComplete, setOpenAutoComplete] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState<any>(null);
  const [options, setOptions] = useState<any[]>([]);
  const [vendorId, setVendorId] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchTermAutocomplete, setSearchTermAutocomplete] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [isEndDateOpen, setIsEndDateOpen] = useState(false);
  const [anchorE3, setAnchorE3] = useState(null);
  const [selectedValue] = useState("");
  const [value, setValue] = useState("1");
  const [searchType, setSearchType] = useState("");
  const [bySelectVendorOpen, setBySelectVendorOpen] = useState(false);
  const [filterInFocus, setfilterInFocus] = useState("");
  const [openList, setOpenList] = useState<string | null>(null);
  const [dateOpen, setdateOpen] = useState(false);

  const classes = useStyles();
  const { id } = useParams();
  const getStatus = useSelector(
    (state: RootState) => state.testAttempts.getTestAnalysisStatus
  );
  const getTestAnalysisData = useSelector(
    (state: RootState) => state.testAttempts.testAanalysis
  );
  const getVendorStatus = useSelector(
    (state: RootState) => state.vendors.getVendorsStatus
  );
  const Vendors = useSelector((state: RootState) => state.vendors.vendors);

  const dispatch = useDispatch<AppDispatch>();

  const updateURL = () => {
    const params = new URLSearchParams(window.location.search);

    const filters = {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
      vendor_id: vendorId,
    };

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        params.set(key, value.toString());
      } else {
        params.delete(key);
      }
    });

    window.history.pushState(
      {},
      "",
      `${window.location.pathname}?${params.toString()}`
    );
  };

  useEffect(() => {
    dispatch(getTestAnalysis({ project_id: id }));
  }, [dispatch]);

  const handleApplyClick = () => {
    dispatch(
      getTestAnalysis({
        project_id: id,
        start_date: formatDate(startDate),
        end_date: formatDate(endDate),
        vendor_id: vendorId,
      })
    );
    updateURL();
    setAnchorE3(null);
  };

  const formatDate = (dateString: any) => {
    return dateString ? format(new Date(dateString), "yyyy-MM-dd") : null;
  };

  useEffect(() => {
    dispatch(
      getVendorAction({
        is_vendorblock: false,
        search_query: searchTermAutocomplete,
      })
    );
  }, [dispatch, searchTermAutocomplete]);

  useEffect(() => {
    if (getVendorStatus === STATUS.SUCESS) {
      setOptions(Vendors.results);
    }
    if (getVendorStatus === STATUS.PENDING) {
      setLoading(true);
    }
    if (getVendorStatus === STATUS.SUCESS) {
      setLoading(false);
    }
  }, [getVendorStatus]);

  const handleAutoCompleteOpen = () => {
    setOpenAutoComplete(true);
  };
  const handleAutoCompleteClose = () => {
    setOpenAutoComplete(false);
  };

  const resetSelectVendor = () => {
    setSelectedVendor(null);
    setVendorId("");
  };
  const handleSearchChangeAutoComplete = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSearchTermAutocomplete(event.target.value.trim());
  };
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value.trim());
  };

  const debouncedResults = useMemo(() => debounce(handleSearchChange, 300), []);
  const debouncedResultsForAutoComplete = useMemo(() => {
    return debounce(handleSearchChangeAutoComplete, 300);
  }, []);

  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    };
  });
  useEffect(() => {
    return () => {
      debouncedResultsForAutoComplete.cancel();
    };
  });

  const handleAutocompleteInput = (e: any) => {
    debouncedResultsForAutoComplete(e);
  };

  const handleStartDateChange = (date: Date | null) => {
    setStartDate(date ?? null);
    setIsEndDateOpen(true);
  };

  const handleEndDateChange = (date: Date | null) => {
    setEndDate(date ?? null);
    setIsEndDateOpen(false);
  };

  const handleClearSelectedDates = () => {
    setEndDate(null);
    setStartDate(null);
  };
  const handleFilterClick = (event: any) => {
    setAnchorE3(event.currentTarget);
  };
  const handleFilterClose = () => {
    setAnchorE3(null);
    setSearchType("");
  };
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const handleBySelectVendorClick = (listName: string) => {
    setBySelectVendorOpen(!bySelectVendorOpen);
    setfilterInFocus("by_select_vendor_open");
    setOpenList((prev) => (prev === listName ? null : listName));
  };
  const handleDateRange = (listName: string) => {
    setdateOpen(!dateOpen);
    setfilterInFocus("by_select_vendor_open");
    setOpenList((prev) => (prev === listName ? null : listName));
  };
  const resetDateRange = () => {
    setStartDate(null);
    setIsEndDateOpen(false);
    setEndDate(null);
  };
  const handleReset = () => {
    const url = window.location.pathname;
    window.history.pushState({}, "", url);
    window.location.reload();
  };
  return (
    <>
      <div style={{ paddingTop: "30px" }}>
        <div
          className="date-range-picker"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginRight: "20px",
            }}
          >
            <Badge color="error">
              <IconButton
                color="primary"
                aria-label="filter options"
                onClick={handleFilterClick}
                value={selectedValue}
                autoFocus={false}
                sx={{
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                  background: "linear-gradient(45deg, #42a5f5, #478ed1)",
                  borderRadius: "30%",
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": {
                    background: "linear-gradient(45deg, #478ed1, #42a5f5)",
                    transform: "scale(1.1)",
                  },
                }}
              >
                <Tooltip title={"Filters"} placement="bottom-end" arrow>
                  <FilterAltIcon fontSize="medium" sx={{ color: "white" }} />
                </Tooltip>
              </IconButton>
            </Badge>
          </Box>
        </div>
        <TableContainer
          sx={{ maxWidth: "100%", mx: "auto", my: 3, borderRadius: 2 }}
        >
          <Table aria-label="custom table">
            {/* Table Head */}
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                {getTestAnalysisData.data &&
                  Object.keys(getTestAnalysisData.data).map(
                    (header: any, i) => {
                      if (
                        typeof getTestAnalysisData.data[header] === "number"
                      ) {
                        return (
                          <TableCell
                            key={i}
                            sx={{
                              fontWeight: "bold",
                              textTransform: "capitalize",
                              padding: 2,
                            }}
                          >
                            {header.replaceAll("_", " ")}
                          </TableCell>
                        );
                      }
                    }
                  )}
              </TableRow>
            </TableHead>

            {/* Table Body */}
            <TableBody>
              <TableRow sx={{ "&:hover": { backgroundColor: "#f9f9f9" } }}>
                {getTestAnalysisData.data &&
                  Object.values(getTestAnalysisData.data).map((value, i) => {
                    if (typeof value === "number") {
                      return (
                        <TableCell
                          key={i}
                          sx={{
                            textAlign: "center",
                            padding: 2,
                            fontSize: "1rem",
                          }}
                        >
                          {value}
                        </TableCell>
                      );
                    }
                  })}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <TableContainer
          sx={{ maxWidth: "100%", mx: "auto", my: 3, borderRadius: 2 }}
        >
          <Table aria-label="role based stats table">
            {/* Table Head */}
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                <TableCell sx={{ fontWeight: "bold", padding: 2 }}>
                  Role
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", padding: 2 }}>
                  Total Experts
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", padding: 2 }}>
                  Passed
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", padding: 2 }}>
                  Failed
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", padding: 2 }}>
                  Not Attempted
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(getTestAnalysisData as any)?.data?.role_based_stats?.map(
                (stat: any, index: number) => (
                  <TableRow
                    key={index}
                    sx={{ "&:hover": { backgroundColor: "#f9f9f9" } }}
                  >
                    <TableCell sx={{ textAlign: "left", padding: 2 }}>
                      {stat.role ?? '-'}
                    </TableCell>
                    <TableCell sx={{ textAlign: "left", padding: 2 }}>
                      {stat.total_experts_on_this_role ?? "-"}
                    </TableCell>
                    <TableCell sx={{ textAlign: "left", padding: 2 }}>
                      {stat.total_passed_on_this_role ?? "-"}
                    </TableCell>
                    <TableCell sx={{ textAlign: "left", padding: 2 }}>
                      {stat.total_failed_on_this_role ?? "-"}
                    </TableCell>
                    <TableCell sx={{ textAlign: "left", padding: 2 }}>
                      {stat.total_not_attempted_on_this_role ?? "-"}
                    </TableCell>
                  </TableRow>
                )
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      <Popover
        // id={id}
        open={Boolean(anchorE3)}
        anchorEl={anchorE3}
        onClose={handleFilterClose}
        anchorOrigin={{
          horizontal: "left",
          vertical: "bottom",
        }}
      >
        <Box sx={{ width: "330px", typography: "body1", height: "337px" }}>
          <TabContext value={value}>
            <Box
              sx={{
                borderBottom: 2,
                borderColor: "divider",
                position: "sticky",
                top: 0,
                backgroundColor: "white",
                zIndex: 1,
              }}
            >
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
              >
                <Tab label="Filters" value="1" />
                <div style={{ position: "absolute", left: "70px", top: "5px" }}>
                  <IconButton
                    onClick={handleFilterClose}
                    color="primary"
                    aria-label=""
                    style={{ marginLeft: "14rem" }}
                  >
                    <CancelIcon color="primary" />
                  </IconButton>
                </div>
                {/* <Tab label="Tasks Filters" value="2" /> */}
              </TabList>
            </Box>

            <List
              disablePadding
              sx={{
                width: "100%",
                maxWidth: 300,
                bgcolor: "background.paper",
                marginLeft: "10px",
              }}
              component="div"
            >
              <div
                style={{
                  display: "flex",
                  cursor: "pointer",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "5px",
                }}
                onClick={() => handleBySelectVendorClick("selectVendor")}
              >
                <ListItemText
                  primary={
                    <Typography
                      style={{ fontSize: "16px", fontFamily: "montserrat" }}
                    >
                      Select Vendor
                    </Typography>
                  }
                  sx={{ fontSize: "20px", fontWeight: "bold" }}
                />
                {openList === "selectVendor" ? <ExpandLess /> : <ExpandMore />}
                <Button
                  onClick={resetSelectVendor}
                  style={{ padding: 0, minWidth: "auto" }}
                >
                  <Tooltip title="Reset vendor">
                    <BlockIcon fontSize="small" color="error" />
                  </Tooltip>
                </Button>
              </div>
              <Collapse
                in={openList === "selectVendor"}
                timeout="auto"
                unmountOnExit
              >
                <div style={{ marginLeft: "20px" }}>
                  <Autocomplete
                    size="small"
                    sx={{ width: 300 }}
                    open={openAutoComplete}
                    onOpen={handleAutoCompleteOpen}
                    onClose={handleAutoCompleteClose}
                    // disabled={selectedRow}
                    autoSelect
                    value={selectedVendor}
                    getOptionLabel={
                      (option) =>
                        option?.pseudo_name
                          ? option?.pseudo_name
                          : option?.vendor_pseudo_name
                      // option.vendor_pseudo_name ? `${option.vendor_name} (${option.vendor_pseudo_name})` : option.vendor_name
                    }
                    // filterOptions={(options) =>
                    //     options.filter(option => option?.pseudo_name)
                    // }
                    options={options
                      .map((a: any) => {
                        return {
                          ...a,
                          vendor_pseudo_name_small:
                            a.pseudo_name?.toLowerCase() ||
                            a.vendor_pseudo_name?.toLowerCase(),
                        };
                      })
                      .filter((a: { vendor_id: string }) => a.vendor_id != "")
                      .sort(
                        (
                          a: { vendor_pseudo_name_small: number },
                          b: { vendor_pseudo_name_small: number }
                        ) =>
                          a.vendor_pseudo_name_small <
                          b.vendor_pseudo_name_small
                            ? -1
                            : a.vendor_pseudo_name_small >
                              b.vendor_pseudo_name_small
                            ? 1
                            : 0
                      )}
                    loading={getVendorStatus === STATUS.PENDING}
                    onChange={(event, value) => {
                      if (value) {
                        setVendorId(value.vendor_id);
                        setSelectedVendor(value);
                      } else {
                        setSelectedVendor(null);
                      }
                    }}
                    renderInput={(params) => {
                      return (
                        <TextField
                          {...params}
                          placeholder="Select Vendor Pseudo Name"
                          size="small"
                          sx={{ width: "85%" }}
                          value={
                            selectedVendor != null ? selectedVendor.name : ""
                          }
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {loading ? (
                                  <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                          onChange={(e) => {
                            handleAutocompleteInput(e);
                          }}
                        />
                      );
                    }}
                  />
                </div>
              </Collapse>
            </List>
            <Divider
              orientation="horizontal"
              variant="fullWidth"
              flexItem
              style={{ marginTop: "5px" }}
            />

            <List
              disablePadding
              sx={{
                width: "100%",
                maxWidth: 300,
                bgcolor: "background.paper",
                marginLeft: "10px",
                marginTop: "10px",
              }}
              component="div"
            >
              <div
                style={{
                  display: "flex",
                  cursor: "pointer",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
                onClick={() => handleDateRange("dateRange")}
              >
                <ListItemText
                  primary={
                    <Typography
                      style={{ fontSize: "16px", fontFamily: "montserrat" }}
                    >
                      Select Date Range
                    </Typography>
                  }
                  sx={{ fontSize: "20px", fontWeight: "bold" }}
                />
                {openList === "dateRange" ? <ExpandLess /> : <ExpandMore />}
                <Button
                  onClick={resetDateRange}
                  style={{ padding: 0, minWidth: "auto" }}
                >
                  <Tooltip title="Reset date range">
                    <BlockIcon fontSize="small" color="error" />
                  </Tooltip>
                </Button>
              </div>

              <Collapse
                in={openList === "dateRange"}
                timeout="auto"
                unmountOnExit
              >
                <ListItem>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <MobileDatePicker
                        value={
                          startDate && dayjs.isDayjs(startDate)
                            ? startDate
                            : startDate
                            ? dayjs(startDate)
                            : null
                        }
                        onChange={(date: any) => handleStartDateChange(date)}
                        format="DD-MM-YYYY"
                        slotProps={{
                          textField: {
                            size: "small",
                            placeholder: "Start Date",
                          } as any,
                        }}
                      />

                      <EastIcon sx={{ fontSize: "16px" }} />

                      <MobileDatePicker
                        value={
                          endDate && dayjs.isDayjs(endDate)
                            ? endDate
                            : endDate
                            ? dayjs(endDate)
                            : null
                        }
                        onChange={(date: any) => handleEndDateChange(date)}
                        format="DD-MM-YYYY"
                        minDate={
                          startDate
                            ? dayjs.isDayjs(startDate)
                              ? startDate
                              : dayjs(startDate)
                            : undefined
                        }
                        slotProps={{
                          textField: {
                            size: "small",
                            placeholder: "End Date",
                          } as any,
                        }}
                      />
                    </LocalizationProvider>

                    <IconButton onClick={handleClearSelectedDates} size="small">
                      <HighlightOffIcon fontSize="small" />
                    </IconButton>
                  </div>
                </ListItem>
              </Collapse>
            </List>
            <Divider
              orientation="horizontal"
              variant="fullWidth"
              flexItem
              style={{ marginBottom: "145px", marginTop: "6px" }}
            />

            <div
              style={{
                backgroundColor: "white",
                position: "sticky",
                bottom: 0,
                zIndex: 1000,
                padding: "10px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <IconButton
                aria-label="Reset"
                color="secondary"
                onClick={handleReset}
              >
                <Tooltip title="Reset" arrow>
                  <RestoreIcon />
                </Tooltip>
              </IconButton>

              <Button
                variant="contained"
                startIcon={<FilterAltIcon />}
                onClick={handleApplyClick}
              >
                Apply
              </Button>
            </div>
          </TabContext>
        </Box>
      </Popover>
    </>
  );
};

export default TestAnalysis;
